/* ------------------------------------------------------------------
   PlushTree localization label
   Added 2026-10-28.

   Tinker's header prints the locale trigger as currency code + language
   code -- "EUR / NL" -- which tells a Dutch shopper nothing useful and
   leads with a currency we do not want surfaced. The full country name and
   the language endonym are already in the page: the country sits in the
   dropdown list item marked aria-current, and the language is the selected
   option of the language <select>. This rewrites the trigger to
   "Nederland / Nederlands" using those real, already-localised values.

   Done in JS rather than in sections/header.liquid so a Tinker theme
   update cannot overwrite it. If a value cannot be found the trigger is
   left exactly as the theme rendered it.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var SKIP = ['currency-code', 'visually-hidden', 'svg-wrapper', 'icon-flag', 'icon-caret'];

  function hasSkippedClass(el) {
    for (var i = 0; i < SKIP.length; i++) {
      if (el.classList.contains(SKIP[i])) return true;
    }
    return false;
  }

  function currentCountryName(root) {
    var item = root.querySelector('.localization-form__list-item[aria-current="true"] .country');
    return item ? item.textContent.trim() : null;
  }

  function currentLanguageName(root) {
    var select = root.querySelector('select.localization-form__select');
    if (!select) return null;
    var opt = select.options[select.selectedIndex];
    return opt ? opt.textContent.trim() : null;
  }

  function decorate(component) {
    if (!component || component.dataset.ptreeLocalized === 'done') return;

    var country = currentCountryName(component);
    var language = currentLanguageName(component);
    if (!country && !language) return;

    var trigger = component.querySelector('button, summary');
    if (!trigger) return;

    // The currency code span becomes the country name.
    var currencyEl = trigger.querySelector('.currency-code');
    if (currencyEl && country) {
      currencyEl.textContent = country;
      currencyEl.classList.add('ptree-locale-country');
    }

    // The remaining bare span inside the trigger holds the language code.
    var spans = trigger.querySelectorAll('span');
    for (var i = 0; i < spans.length; i++) {
      var s = spans[i];
      if (s === currencyEl) continue;
      if (hasSkippedClass(s)) continue;
      if (s.querySelector('span, svg')) continue;
      var txt = s.textContent.trim();
      if (!txt || txt === '/') continue;
      if (txt.length <= 5 && language) {
        s.textContent = language;
        s.classList.add('ptree-locale-language');
        break;
      }
    }

    component.dataset.ptreeLocalized = 'done';
  }

  function run() {
    var components = document.querySelectorAll(
      'dropdown-localization-component, drawer-localization-component, localization-form-component'
    );
    for (var i = 0; i < components.length; i++) {
      // localization-form-component holds the list; walk up to the wrapper that also holds the trigger.
      var node = components[i];
      var host = node.closest('dropdown-localization-component, drawer-localization-component') || node;
      decorate(host);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Shopify re-renders header sections on locale/cart changes; re-apply then.
  document.addEventListener('shopify:section:load', run);
  new MutationObserver(function () {
    run();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();